import React, { useMemo, useState, useEffect, useRef } from 'react';
import { connect, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button, Col, Collapse, Navbar, NavbarToggler } from 'reactstrap';
import BellIcon from 'react-bell-icon';
import { getOverview } from '../../actions/Home';
import { disableDeleteMode, enableDeleteMode, logout, toggleCollapse } from '../../actions/User';
import { updateUserById } from '../../actions/Users';
import { ReactComponent as EpikLogoSvg } from '../../Res/granite-logo.svg';
import Navigation from '../Navigation';
import '../Navigation.css';
import AddSecurityCodeModal from '../AddSecurityCodeModal';
import {
  latestReleaseNote,
  getMaintenanceNotes,
  setMaintenanceNoteSeen,
} from '../../actions/EpikBoxes';
import Countdown from '../Countdown';
import Notification from './Notification';
import WebsiteNotificationBar from '../WebsiteNotificationBar';
import Crums from '../Crums';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import CustomModal from '../CustomModal';
import { toast } from 'react-toastify';
import EpikToggle from '../EpikToggle';
import * as SystemActions from '../../actions/SystemLogs';
import { getPermissionForComponent } from '../../utils/permissionsUtils';

const url = require('url');

const Header = ({
  user,
  logout,
  children,
  enableDeleteMode,
  disableDeleteMode,
  deleteMode,
  collapse,
  toggleCollapse,
  getOverview,
  securityCode,
  latestReleaseNote,
  getMaintenanceNotes,
  setMaintenanceNoteSeen,
  updateUserById,
  addSystemLogs,
  intervalId
}) => {
  const location = useLocation();

  const maintenanceUpdate = useSelector(store => store.AppState.boxDetails.maintenanceNotification);
  const permissionGroupsList = useSelector(store => store.AppState.permissionGroups);

  const [bannerStatus, setBannerStatus] = useState(false);
  const [bannerText, setBannerText] = useState('');
  const [maintenanceBanners, setmaintenanceBanners] = useState([]);
  const [showMaintenanceBanners, setShowMaintenanceBanners] = useState(false);
  const [isSecurityBannerEnabled, setIsSecurityBannerEnabled] = useState(false);
  const [headerPad, setHeaderPad] = useState(56);
  const headerRef = useRef(null);

  const token = localStorage.getItem('jwtToken') || null;

  useEffect(() => {
    if (headerRef.current) setHeaderPad(headerRef.current.offsetHeight || 56);
  }, [bannerStatus, collapse]);

  useEffect(() => {
    if (user?.company?.loginSecurityBanner?.enabled && user?.company?.loginSecurityBanner?.text && !user?.isSecurityAcknowledged) {
      setIsSecurityBannerEnabled(user?.company?.loginSecurityBanner?.enabled)
    }
  }, [user])

  const enableDevMode = () => {
    global.deleteMode = true;
    enableDeleteMode();
    getOverview(token);
  };

  useEffect(() => {
    if (maintenanceUpdate?.maintenanceAlert?.length > 0) {
      setBannerStatus(true);
      const priorityBanner = maintenanceUpdate?.maintenanceAlert?.filter(
        notify => notify.priority === 1,
      );
      setBannerText(priorityBanner[0].description);
      setmaintenanceBanners(maintenanceUpdate?.maintenanceAlert?.reverse());
    }
  }, [maintenanceUpdate]);

  useMemo(async () => {
    try {
      const { maintenanceAlert: releaseNotes } = await latestReleaseNote(token);
      if (releaseNotes?.length > 0) {
        const priorityBanner = releaseNotes.filter(notify => notify.priority === 1);
        setBannerText(priorityBanner[0].description);
        setmaintenanceBanners(releaseNotes?.reverse());
        setBannerStatus(true);
      }
    } catch (error) {
      // Handle the error here, e.g., log it or display a user-friendly message.
      console.error('Error fetching maintenance alert:', error.message);
    }
  }, []);
  const navStyle = {
    width: '100%',
    minWidth: 240,
    backgroundColor: '#fcfdff',
  };
  const onLogoutPress = async () => {
    const token = localStorage.getItem('jwtToken');
    await logout(token, intervalId);
    const body = {
      actionType: 'system',
      description: `User Logout`,
    };
    await addSystemLogs(token, body);
  };

  const displayNotifications = async () => {
    setShowMaintenanceBanners(!showMaintenanceBanners);
  };

  const getActiveNotificationsIds = async () => {
    return maintenanceBanners?.reduce((filteredIds, note) => {
      filteredIds.push(note?._id);
      return filteredIds;
    }, []);
  };

  const clearUserNotifications = async () => {
    const activeNotificationsIds = await getActiveNotificationsIds();
    const seen = await setMaintenanceNoteSeen(token, activeNotificationsIds);
    if (seen) {
      setmaintenanceBanners([]);
      setBannerStatus(false);
    }
  };

  const onCancelHandler = async () => {
    setIsSecurityBannerEnabled(false)
    onLogoutPress()
  }

  const onAcknowledgeHandler = async () => {
    const token = localStorage.getItem('jwtToken');
    const resp = await updateUserById(token, user?._id, { isSecurityAcknowledged: true });

    if (resp?.data?.isSecurityAcknowledged) {
      setIsSecurityBannerEnabled(false);
      const body = {
        actionType: 'system',
        description: `User: ${user?.name} with Email: ${user?.email} acknowledged a security banner`,
      };
      await addSystemLogs(token, body);
    } else {
      toast.error(`Something went wrong while security banner acknowledgement.`)
    }
  }

  if (isSecurityBannerEnabled) {
    return (
      <CustomModal
        isOpen={isSecurityBannerEnabled}
        header={user?.company?.loginSecurityBanner?.title || 'WARNING'}
        onSave={() => onAcknowledgeHandler()}
        onCancel={() => onCancelHandler()}
        saveBtnText={'Acknowledge'}
        customBodyClass={'security-banner'}
        medium
      >
        <div
          dangerouslySetInnerHTML={{
            __html: user?.company?.loginSecurityBanner?.text,
          }}
        />
      </CustomModal>
    )
  }

  return (
    <>
      <div ref={headerRef} style={{ position: 'fixed', top: 0, zIndex: 999, width: '100%', marginTop: 0 }}>
        <WebsiteNotificationBar isOpen={bannerStatus} toggle={() => setBannerStatus(false)}>
          {bannerText}
        </WebsiteNotificationBar>
        <Navbar style={navStyle} expand="sm">
          <Link to="/" className="navbar-brand" aria-label="Go to Home">
            <Button
              color="link"
              onClick={() => {
                const urlObj = url.parse(document.location.href, true);
                if (user?.permissionsGroup === 'Engineering' && urlObj.pathname === '/') {
                  enableDevMode();
                }
                if (user.role === 'superAdmin') {
                  getOverview(localStorage.getItem('jwtToken') || null);
                }
              }}
            >
              <EpikLogoSvg
                width={80}
                height={40}
                aria-hidden="true"
                role="presentation"
                focusable="false"
                title="Granite EPIK Logo"
              />
            </Button>
          </Link>   
          {(user?.epikEngineering||
            user?.epikV2Access ||
            user?.permissionsGroup === 'Engineering' ||
            getPermissionForComponent('epikV2Access', user?.permissionsGroup)) && (
            <EpikToggle />
          )}
          {deleteMode && (
            <Col xs="auto">
              <Link to="/">
                <Button
                  outline
                  size="sm"
                  color="danger"
                  onClick={() => {
                    global.deleteMode = false;
                    disableDeleteMode();
                    getOverview(localStorage.getItem('jwtToken') || null);
                  }}
                >
                  EPIK Dev Mode
                </Button>
              </Link>
            </Col>
          )}
          <Button
            title="Your account has read only access"
            hidden={!user.readOnly}
            outline
            size="sm"
            color="danger"
          >
            Read Only Mode
          </Button>
          <Col xs="auto">
            <Countdown />
          </Col>
          <NavbarToggler
            className={collapse ? 'custom-toggler-close' : 'custom-toggler-hamburger'}
            onClick={() => toggleCollapse(!collapse)}
          />
          <Collapse isOpen={collapse} navbar>
            <Navigation mobile={collapse} user={user} onLogout={onLogoutPress} permissionGroupsList={permissionGroupsList} />
          </Collapse>

          {maintenanceBanners.length > 1 && (
            <div
              className="maintenance-banners"
              data-count={maintenanceBanners.length > 9 ? `9+` : maintenanceBanners.length}
              onClick={displayNotifications}
            >
              <BellIcon color="#3b59a9" width="20" active animate style={{ margin: '0 10px' }} />
              {showMaintenanceBanners && (
                <Notification
                  maintenanceBanners={maintenanceBanners}
                  clearUserNotifications={clearUserNotifications}
                />
              )}
            </div>
          )}
        </Navbar>
      </div>
      <div style={{ height: headerPad }} />
      {location?.pathname === '/' ? null : (
        <div>
          <Crums />
        </div>
      )}

      <div>
        {children}
      </div>
    </>
  );
};

const mapStateToProps = store => ({
  user: store.AppState.user,
  deleteMode: store.AppState.deleteMode,
  collapse: store.UIState.toggleCollapse,
  securityCode: store.UIState.users.addedUser.security,
  latestRelease: store.AppState.boxDetails.latestRelease,
  permissionGroupsList : store.AppState.permissionGroups,
  intervalId: store.UIState.users.intervalId
});

const mapDispatchToProps = dispatch => ({
  logout: (token, interval) => dispatch(logout(token, interval)),
  toggleCollapse: val => dispatch(toggleCollapse(val)),
  enableDeleteMode: () => dispatch(enableDeleteMode()),
  disableDeleteMode: () => dispatch(disableDeleteMode()),
  getOverview: token => dispatch(getOverview(token)),
  latestReleaseNote: token => dispatch(latestReleaseNote(token)),
  getMaintenanceNotes: token => dispatch(getMaintenanceNotes(token)),
  setMaintenanceNoteSeen: (token, activeNotificationsIds) =>
    dispatch(setMaintenanceNoteSeen(token, activeNotificationsIds)),
  updateUserById: (token, id, userObj) =>
    dispatch(updateUserById(token, id, userObj)),
  addSystemLogs: (token, body) => dispatch(SystemActions.addSystemLogs(token, body)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Header);
